import ToolTip from "components/design/toolTip";
import {
  QuarterlyAdvanceTaxMetadata,
  YearlyAdvanceTaxMetadata,
} from "store/apis/products";
import { Info } from "components/icons/Info";

export const AdvanceTaxDeadline = ({
  metadata,
  isYearly,
  selectedQuarter,
}: {
  metadata?: YearlyAdvanceTaxMetadata | QuarterlyAdvanceTaxMetadata;
  isYearly: boolean;
  selectedQuarter: string;
}) => {
  if (isYearly) {
    return (
      <div className="t-flex t-flex-col">
        {(metadata as YearlyAdvanceTaxMetadata).map((item, index) => (
          <div key={index} className="t-flex t-items-center">
            <span className="t-text-text-30 t-text-subtext">
              Quarter {index + 1}:
            </span>
            <span className="t-text-text-100 t-text-subtext t-font-bold t-mx-1">
              {item.deadline}
            </span>
            <ToolTip text={item.tooltip}>
              <span className="t-text-text-30 -t-mt-1">
                <Info />
              </span>
            </ToolTip>
          </div>
        ))}
      </div>
    );
  }

  const quarterData = (metadata as QuarterlyAdvanceTaxMetadata)?.find(
    (item) => item.value === selectedQuarter
  );

  return (
    <span className="t-text-text-100 t-text-subtext t-font-bold">
      {quarterData?.deadline || "-"}
    </span>
  );
};
